import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scrollTo";

const LINKS = [
  { id: "work", label: "Work" },
  { id: "services", label: "Services" },
  { id: "studio", label: "Studio" },
  { id: "process", label: "Process" },
  { id: "reviews", label: "Reviews" },
  { id: "brief", label: "Start a Project" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-gray-100 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-24 md:pb-8 relative z-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="text-gray-500 text-sm leading-relaxed mt-5 max-w-sm">
              Full-spectrum video editing, animation and production for creators, channels and brands.
            </p>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-mono text-[11px] tracking-[0.25em] text-gray-400 uppercase mb-5">Explore</h4>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    type="button"
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-gray-500 hover:text-crimson transition-colors duration-300"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <h4 className="font-mono text-[11px] tracking-[0.25em] text-gray-400 uppercase mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-500">
              <li>
                <a href="mailto:business.vrmedia@gmail.com" data-testid="footer-email-link" className="hover:text-crimson transition-colors duration-300">
                  business.vrmedia@gmail.com
                </a>
              </li>
              <li>India · Serving creators worldwide</li>
              <li>
                <a href="/track" data-testid="footer-track-link" className="inline-flex items-center gap-1.5 text-gray-700 hover:text-crimson transition-colors duration-300">
                  Track your brief <span aria-hidden>→</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 mt-14 pt-7">
          <p className="text-xs text-gray-400">© 2026 Vertex Production. All rights reserved.</p>
        </div>
      </div>

      <div className="relative select-none pointer-events-none -mb-6 md:-mb-10">
        <div className="font-display font-extrabold tracking-tight text-center text-stroke text-[16vw] leading-none whitespace-nowrap">
          VERTEX
        </div>
      </div>
    </footer>
  );
}
